// import { Toast, ToastContainer } from "react-bootstrap";

// const ToastMessage = ({
//   show,
//   onClose,
//   message,
//   type = "success",
//   delay = 3000,
// }) => {
//   const bgColor = type === "error" ? "danger" : "success";

//   return (
//     <>
//       {show && (
//         <ToastContainer position="top-end" className="p-3">
//           <Toast
//             onClose={onClose}
//             show={show}
//             delay={delay}
//             autohide
//             bg={bgColor}
//           >
//             <Toast.Body className="text-white fw500">{message}</Toast.Body>
//           </Toast>
//         </ToastContainer>
//       )}
//     </>
//   );
// };

// export default ToastMessage;

import { Toast, ToastContainer } from "react-bootstrap";

const ToastMessage = ({
  show,
  onClose,
  message,
  type = "success",
  delay = 3000,
  position = "top-end",
}) => {
  const bgColor = type === "error" ? "danger" : "success";

  return (
    <>
      {show && (
        <ToastContainer
          position={position}
          className="p-3"
          style={{ position: "fixed", zIndex: 9999 }}
        >
          <Toast
            onClose={onClose}
            show={show}
            delay={delay}
            autohide
            bg={bgColor}
          >
            <Toast.Body className="text-white fw500">{message}</Toast.Body>
          </Toast>
        </ToastContainer>
      )}
    </>
  );
};

export default ToastMessage;
